import { Construction } from "lucide-react";

export const MaintenanceScreen = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="text-center max-w-md space-y-6">
        <div className="mx-auto w-16 h-16 rounded-full bg-muted flex items-center justify-center">
          <Construction className="w-8 h-8 text-primary" />
        </div>
        <h1 className="text-2xl font-bold text-foreground">
          We're Preparing Something Special
        </h1>
        <p className="text-muted-foreground leading-relaxed">
          LupusLogix is currently undergoing maintenance. Your data is safe and
          we'll be back shortly. Thank you for your patience!
        </p>
        <p className="text-sm text-muted-foreground/70">
          If you have questions, reach out to us at{" "}
          <a
            href="mailto:support@lupuslogix.com"
            className="text-primary underline hover:no-underline"
          >
            support@lupuslogix.com
          </a>
        </p>
      </div>
    </div>
  );
};
